export enum PersonTypeEnum {
    REPRESENTATIVE = "representative",
    CONTACT = "contact",
    MANAGER = "manager",
}
